import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {notification} from 'antd'
import InputForm from './InputForm'

import './index.scss'

const setVideoInputMutation = gql`
  mutation SetVideoInput($input: SetVideoInputInput!) {
    SetVideoInput(input: $input) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
        ...on VideoProduct {
          features {
            id
            name
            value
          }
          facts {
            id
            name
            value
          }
        }
      }
    }
  }
`

const ProvideInput = ({product, productAvailability, broker}) => {
  const videoType = productAvailability.videoTypes.find(o => o.type === product.videoVariant)
  let initialFacts = product.facts
  let initialFeatures = product.features

  if (initialFacts.length === 0) {
    initialFacts = productAvailability.videoFacts.map(fact => {
      if (fact.name === 'agentName') fact.value = broker.name
      if (fact.name === 'agentPhone') fact.value = broker.phone
      if (fact.name === 'agentEmail') fact.value = broker.email
      return fact
    })
  }

  if (initialFeatures.length === 0) {
    initialFeatures = videoType.features.filter(f => !f.optional || !f.customizable)
  }

  const handleSubmit = ({facts, features}, mutation) => {
    return mutation({
      variables: {
        input: {
          productId: product.id,
          facts: JSON.stringify(facts.map(f => ({name: f.name, value: f.value}))),
          features: JSON.stringify(features.map(f => ({name: f.name, value: f.value}))),
        }
      }
    })
  }

  return (
    <div className="provide-input">
      <Mutation
        mutation={setVideoInputMutation}
        onCompleted={() => {
          notification.success({
            message: 'Underlag lastet opp',
            description: 'Underlaget ble lastet opp og produktet sendes nå til produksjon.',
          })
        }}
        onError={() => {
          notification.error({
            message: 'Underlag feilet',
            description: 'Kunne ikke laste opp underlag grunnet en feil. Forsøk på nytt senere.',
          })
        }}
      >
        {(setVideoInput, {loading}) => (
          <InputForm
            facts={initialFacts}
            features={initialFeatures}
            maxFeatures={videoType.features.length}
            onSubmit={data => handleSubmit(data, setVideoInput)}
            isSubmitting={loading}
          />
        )}
      </Mutation>
    </div>
  )
}

ProvideInput.propTypes = {
  product: PropTypes.object.isRequired,
  productAvailability: PropTypes.object.isRequired,
  broker: PropTypes.object,
}

export default ProvideInput
